import _ from 'lodash'
import qs from 'qs'
import React from 'react'
import {string, arrayOf, shape} from 'prop-types'
import {graphql} from 'gatsby'
import glamorous from 'glamorous'

import Default from '../layouts/default'
import PostPreview from '../components/post-preview'
import CardHover from '../components/card-hover'

// const removeHeadings = (excerpt, headingsArr) =>
//   _.reduce(headingsArr, (ex, {value}) => ex.replace(value, ''), excerpt)

const prefixBlogPath = path => `/writing${path}`

const filterPostsByTag = (posts, tag) => _.filter(posts, post => _.includes(post.node.frontmatter.tags, tag))

const BlogPosts = props => {
  let posts = props.data.allMarkdownRemark.edges

  const tagQuery = qs.parse(props.location.search)
  const tag = tagQuery.tag
  if (tag) {
    posts = filterPostsByTag(posts, tag)
  }

  const postPreviews = _.map(posts, ({node}, i) => {
    const {
      frontmatter: {title, path, featuredImage, short, date, tags, locations},
    } = node
    return (
      <React.Fragment key={path}>
        <CardHover>
          <PostPreview
            path={prefixBlogPath(path)}
            featuredImage={featuredImage}
            title={title}
            date={date}
            tags={tags}
            locations={locations}
            short={short}
            renderLinks={false}
            queryPrefix="/writing"
          />
        </CardHover>
        {/* Spacing Between Previews */}
        <glamorous.Div css={{marginTop: '2rem', marginBottom: '2rem'}} />
      </React.Fragment>
    )
  })

  return (
    <Default
      title={'Writing'}
      location={props.location}
      description={'A collection of thoughts on technology, art, and travel'}
    >
      {postPreviews}
    </Default>
  )
}

BlogPosts.propTypes = {
  location: shape({
    pathname: string.isRequired,
  }),
  allMarkdownRemark: shape({
    edges: arrayOf(
      shape({
        node: shape({
          frontmatter: shape({
            title: string.isRequired,
            path: string.isRequired,
            date: string.isRequired,
            tags: arrayOf(string),
            locations: arrayOf(string),
          }).isRequired,
        }).isRequired,
      })
    ).isRequired,
  }),
}

export default BlogPosts

export const pageQuery = graphql`
  query BlogPosts {
    allMarkdownRemark(
      sort: {order: DESC, fields: [frontmatter___date]}
      filter: {fields: {type: {eq: "writing"}}}
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            path
            title
            short
            date(formatString: "YYYY-MM-DD")
            tags
            locations
            featuredImage {
              childImageSharp {
                ...featuredImageTiny
              }
            }
          }
          headings {
            value
          }
        }
      }
    }
  }
`
